import React, { useState, useCallback } from 'react';
import { getRisks } from '../../api/risks';
import useApi from '../../hooks/useApi';
import TopBar from '../layout/TopBar';
import RisksFilters from './RisksFilters';
import RisksList from './RisksList';
import LoadingState from '../shared/LoadingState';
import ErrorState from '../shared/ErrorState';
import EntryDetailModal from '../entries/EntryDetailModal';

function RisksView({ showToast }) {
  const [filters, setFilters] = useState({ status: 'abierto', impact: '', search: '', page: 1, limit: 20 });
  const [selectedEntryId, setSelectedEntryId] = useState(null);

  const apiFn = useCallback(() => {
    const params = { status: filters.status, page: filters.page, limit: filters.limit };
    if (filters.impact) params.impact = filters.impact;
    if (filters.search) params.search = filters.search;
    return getRisks(params);
  }, [filters]);

  const { data, meta, loading, error, refetch } = useApi(apiFn, [filters]);

  function handleRiskClick(risk) {
    const entryId = risk.entry?.id;
    if (entryId) setSelectedEntryId(entryId);
  }

  const subtitle = meta ? `${meta.total} riesgo${meta.total !== 1 ? 's' : ''} ${filters.status}` : '';

  return (
    <div className="view-container">
      <TopBar title="Riesgos" subtitle={subtitle} />
      <div className="view-content">
        <RisksFilters filters={filters} onChange={setFilters} />
        {loading && <LoadingState rows={5} />}
        {error   && <ErrorState message={error} onRetry={refetch} />}
        {!loading && !error && (
          <RisksList
            risks={data || []}
            meta={meta}
            page={filters.page}
            onPageChange={p => setFilters(f => ({ ...f, page: p }))}
            onUpdated={refetch}
            onRiskClick={handleRiskClick}
            showToast={showToast}
          />
        )}
      </div>

      <EntryDetailModal
        entryId={selectedEntryId}
        onClose={() => setSelectedEntryId(null)}
        showToast={showToast}
      />
    </div>
  );
}

export default RisksView;
